import React from 'react';
interface EyebrowProps {
  children: React.ReactNode;
  className?: string;
}
export function Eyebrow({
  children,
  className = ''
}: EyebrowProps) {
  return <p className={`font-sans text-[0.6875rem] uppercase tracking-label ${className}`} data-id="element-265" data-mp="2567k67zw0k17">{children}</p>;
}